import { Link } from 'react-router-dom';
import styled from 'styled-components';
import useCountryParam from 'utils/hooks/useCountryParam';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    max-width: 40rem;
`;

const Heading = styled.span`
    font-weight: 500;
    color: ${({ theme }) => theme.gray_2};
`;

const Message = styled.span`
    text-wrap: balance;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: ${({ theme }) => theme.gray_2};

    a {
        color: ${({ theme }) => theme.purple_1};
    }

    a:hover {
        color: ${({ theme }) => theme.purple};
        text-decoration: underline;
    }
`;

function TikTokPostsNoDataMessage() {
    const { currentCountryParam, mutateToWithCountryParam } = useCountryParam();
    return (
        <Wrapper>
            <Heading>No posts to display.</Heading>
            {currentCountryParam && currentCountryParam !== 'GLOBAL' ? (
                <Message>
                    Spate was unable to attribute any specific posts to views in
                    the {currentCountryParam} market. Try switching to{' '}
                    <Link
                        to={mutateToWithCountryParam({
                            search: `?country=GLOBAL`,
                        })}
                    >
                        Global
                    </Link>{' '}
                    to view all posts.
                </Message>
            ) : null}
        </Wrapper>
    );
}

export default TikTokPostsNoDataMessage;
